import { SENTRY_DSN } from 'constants.js'
import * as Sentry from '@sentry/browser'

const SENTRY_IGNORE_PATTERN = [
    /Handler for caststatechanged event failed/,
    /Cannot read property 'vdata[0-9]*' of null/,
]

export default () => {
    const { hostname } = window.location

    if (process.env.NODE_ENV === 'development') return

    Sentry.init({ dsn: SENTRY_DSN, environment: hostname })

    const _error = console.error

    console.error = (...args) => {
        _error(...args)

        if (
            args.every(argument => {
                return SENTRY_IGNORE_PATTERN.every(
                    pattern =>
                        (typeof argument === 'string' && !argument.match(pattern)) ||
                        (typeof argument === 'object' && !argument.message.match(pattern)) ||
                        (typeof argument !== 'object' && typeof argument !== 'string'),
                )
            })
        ) {
            Sentry.withScope(scope => {
                scope.setTag('console', 'error')
                Sentry.captureMessage(args.join(' '), 'warning')
            })
        }
    }
}
